import React, { useEffect, useState } from "react"
import ReactPlayer from "react-player/youtube"

// Function to validate and sanitize YouTube URLs
const validateAndSanitizeYouTubeUrl = (url) => {
    if (!url || typeof url !== "string") {
        console.error("Invalid URL: not a string or empty", url)
        return null
    }

    // Remove any whitespace
    const cleanUrl = url.trim()

    // Regular expressions to match different YouTube URL formats
    const patterns = [
        // Standard YouTube URLs
        /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})/,
        // YouTube short URLs
        /(?:https?:\/\/)?youtu\.be\/([a-zA-Z0-9_-]{11})/,
        // YouTube embed URLs
        /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/,
        // YouTube URLs with additional parameters
        /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?.*v=([a-zA-Z0-9_-]{11})/,
    ]

    for (const pattern of patterns) {
        const match = cleanUrl.match(pattern)
        if (match && match[1]) {
            const videoId = match[1]
            const sanitizedUrl = `https://www.youtube.com/watch?v=${videoId}`
            return sanitizedUrl
        }
    }

    // Check if it's already a valid YouTube URL that react-player can handle
    if (ReactPlayer.canPlay(cleanUrl)) {
        return cleanUrl
    }

    return null
}

export function YoutubePlayer({ url }) {
    const [validatedUrl, setValidatedUrl] = useState(null)

    useEffect(() => {
        // Validate the URL first
        const sanitized = validateAndSanitizeYouTubeUrl(url)
        setValidatedUrl(sanitized)

        if (!sanitized) {
            return
        }
    }, [url])

    return (
        <ReactPlayer
            url={validatedUrl}
            playing
            controls
            width="100%"
            height="100%"
        />
    )
}
